import { http, uploadFile } from '@/utils/axios'

/**
 * @msg: 课程架构接口
 */

//增加节点/编辑视频弹题/编辑试卷列表
export function addCourseStructure(data) {
    return http({
        url: http.baseUrl('elZyVideoSection/addZyVideoSection'),
        method: 'post',
        params: http.params(data),
    })
}
//删除节点
export function deleteCourseStructure(data) {
    return http({
        url: http.baseUrl('elZyVideoSection/updateStatus'),
        method: 'post',
        params: http.params(data),
    })
}
//查询列表
export function getList(data) {
    return http({
        url: http.baseUrl('elZyVideoSection/getList'),
        method: 'get',
        params: http.params(data),
    })
}

//根据课程id获取课件id
export function getCourseId(data) {
    return http({
        url: http.baseUrl('/courseWare/getCourseId'),
        method: 'get',
        params: http.params(data),
    })
}

//上传文件返回id
export function addUploadFile(data) {
    return http({
        url: http.baseUrl('file/addUploadFile'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}
//编辑节点
export function updateVideoData(data) {
    return http({
        url: http.baseUrl('elZyVideoSection/updateVideoData'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}

//查询知识清单
export function knowLegGetList(data) {
    return http({
        url: http.baseUrl('knowledge/getList'),
        method: 'get',
        params: http.params(data),
    })
}

/**
 * @msg: 通过uid获取机构
 */
export function getSchoolByUid(uid) {
    return http({
        url: http.baseUrl('elSchool/getSchoolByUid'),
        method: 'get',
        params: http.params({
            uid
        })
    })
}


/**
 * @msg: 获取课件列表
 */
export function getList2(data) {
    return http({
        url: http.baseUrl('zkolVideoData/getList'),
        method: 'POST',
        params: http.params(data),
        data: data
    })
}


/**
 * @msg: 获取面授列表
 */
export function getTeacherCourseList(data) {
    return http({
        url: http.baseUrl('elZyVideoSection/getTeacherCourseList'),
        method: 'POST',
        params: http.params(data),
        data: data
    })
}

/**
 * @msg: 获取直播列表
 */
export function getZyVideoList(data) {
    return http({
        url: http.baseUrl('elZyVideoSection/getZyVideoList'),
        method: 'POST',
        params: http.params(data),
        data: data
    })
}

/**
 * @msg: 预览查看详情
 */
export function getDetail(data) {
    return http({
        url: http.baseUrl('zkolVideoData/getDetail'),
        method: 'POST',
        params: http.params(data),
        data: data
    })
}



/**
 * @msg: 获取试题列表
 */
export function getQuestionList(data) {
    return http({
        url: http.baseUrl('elZyVideoSection/getQuestionList'),
        method: 'POST',
        params: http.params(data),
        data: data
    })
}


/**
 * @msg: 获取试卷列表
 */
export function getPaperList(data) {
    return http({
        url: http.baseUrl('elZyVideoSection/getPaperList'),
        method: 'POST',
        params: http.params(data),
        data: data
    })
}

/**
 * @msg: 查看课程信息
 */
export function viewCourseDetail(id) {
    return http({
        url: http.baseUrl('courseDetail/viewCourseDetail'),
        method: 'POST',
        params: http.params({
            id
        }),
    })
}


/**
 * @msg: 下载详情文件
 */
export function getFile(id) {
    return http({
        url: http.baseUrl('elZyVideoSection/getFile'),
        method: 'POST',
        params: http.params({
            id
        }),
    })
}



/**
 * @msg: 课件架构排序。
 */
export function updateSort(id1, id2) {
    return http({
        url: http.baseUrl('elZyVideoSection/updateSort'),
        method: 'POST',
        params: http.params({
            id1,
            id2
        }),
    })
}

/**
 * @msg: 获取视频知识点名称
 */
export function getKnowledgeName(data) {
    return http({
        url: http.baseUrl('elZyVideoSection/getKnowledgeName'),
        method: 'get',
        params: http.params(data),
    })
}

/**
 * @msg: 获取考试/测验/练习试卷。
 */
export function getListByExams(data) {
    return http({
        url: http.baseUrl('elExamsPaper/getListByExams'),
        method: 'POST',
        params: http.params(data),
        data: data
    })
}


/**
 * @msg: 获取数量接口 https://gz.hnjk.net/zkfz/elZyVideoSection/getResourceTotal?courseId=227&courseWareId=ff8080814c0d20ba014c0d589d3e0372TK
 */
export function getResourceTotal(data) {
    return http({
        url: http.baseUrl('elZyVideoSection/getResourceTotal'),
        method: 'get',
        params: http.params(data),
    })
}